module.exports = __webpack_public_path__ + "img/icon_lock.43006a24.svg";